var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('no-ssr',[(_vm.carouselProducts.length)?_c('SfCarousel',{staticClass:"m-product-carousel",attrs:{"settings":{
      type: 'slider',
      animationDuration: 250,
      rewindDuration: 500,
      rewind: true,
      perView: 4,
      peek: {
        before: 0,
        after: 50,
      },
      slidePerPage: false,
      breakpoints: {
        767: {
          perView: 1,
        },
        991: {
          perView: 2,
        },
        1200: {
          perView: 3,
        },
      }
    }}},_vm._l((_vm.carouselProducts),function(product,i){return _c('SfCarouselItem',{key:i},[_c('SfProductCard',{attrs:{"sku":product.sku,"title":product.title,"description":product.description,"image":product.image,"min-price":product.price.min,"regular-price":product.price.regular,"special-price":product.price.special,"base-price":product.base_price,"selling-unit":product.selling_unit,"max-rating":product.rating.max,"score-rating":product.rating.score,"link":product.link,"badges":product.badges,"bundle-options":product.bundle_options,"stock":product.stock,"wishlist-icon":false,"reviews":product.reviews,"link-tag":"router-link"}})],1)}),1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }